import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const error: SxStyle = {
  padding: (p) => p.spacing(1, 1.5),
  mt: 2,
};

export const table: SxStyle = {
  mt: 2,
};

export const updateTypeCell: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.75),
};

export const numericCell: SxStyle = {
  textAlign: 'right',
  whiteSpace: 'nowrap',
};

export const progress: SxStyle = {
  display: 'block',
  ml: 'auto',
};

export const summaryRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  mt: 2,
  p: (p) => p.spacing(1),
  borderRadius: (p) => p.spacing(0.5),
  backgroundColor: (p) => p.palette.grey[100],
};

export const totalRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  mt: 1,
  p: (p) => p.spacing(1),
  borderRadius: (p) => p.spacing(0.5),
  border: (p) => `1px solid ${p.palette.primary[200]}`,
};
